<template>
  <div class="coin-record-card">
    <!-- 頂部金幣餘額區 -->
    <div class="balance-header">
      <div class="balance-left">
        <svg width="50" height="50" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
            <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
            <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
            <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 0 -2; 0 0"
                keyTimes="0; 0.5; 1"
                dur="0.6s"
                repeatCount="indefinite" />
          </g>
        </svg>
        <div>
          <div class="balance-title">{{ $t('studentProgramme.coinBalance') }}</div>
          <div class="balance-num">{{ Number(userCardsRoleNum).toLocaleString() }}</div>
        </div>
      </div>
      <div class="balance-right">
        <!--        <span class="pulls-tag">≈ {{ approxPulls }} {{ $t('coin.pulls') }}</span>-->
        <el-icon class="arrow-icon"><ArrowUp /></el-icon>
      </div>
    </div>

    <!-- 分割線 -->
    <div class="divider"></div>

    <!-- 最近流水列表 -->
    <div class="activity-section">
      <div class="activity-title">{{ $t('studentProgramme.recentActivity') }}</div>
      <div class="activity-list">
        <div class="activity-item" v-for="(item, idx) in tableData" :key="idx">
          <div class="item-left">
            <div class="item-icon"></div>
            <div class="item-desc">{{ item.remark }}</div>
          </div>
          <div class="item-right">
            <span :class="{'coin-plus': item.num > 0, 'coin-minus': item.num < 0}">
              {{ item.num > 0 ? '+' : '' }}{{ item.num }}
              <span class="m-icon">
                <svg width="25" height="25" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g>
                    <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                    <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                    <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
                  </g>
                </svg>
              </span>
            </span>
            <span class="time-text">{{ item.createdAt.date | formatDateTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCardsNumUser, getUserCardsRoleNum} from "@/api/cards";
export default {
  data() {
    return {
      listQuery: {
        nameLike: null,
        userNoLike: null,
        orderBy: null,
        _page: 1,
        _limit: 8,
      },
      total: 0,
      tableData: [],
      userCardsRoleNum: 0,
      approxPulls: 35,
      activityList: [
        { desc: this.$t('coin.homeworkCompleted'), amount: 20, timeAgo: '2h ago' },
        { desc: this.$t('coin.singlePull'), amount: -3, timeAgo: '3h ago' },
        { desc: this.$t('coin.adventureCleared'), amount: 15, timeAgo: '1d ago' },
        { desc: this.$t('coin.tenPull'), amount: -27, timeAgo: '1d ago' },
        { desc: this.$t('coin.weeklyBonus'), amount: 100, timeAgo: '3d ago' },
      ]
    };
  },
  filters: {
    // 規則：
    // 小於24小時 → Xh ago
    // ≥24h 且 <7天 → Xd ago（第三天以前）
    // ≥7天 → 顯示 YYYY-MM-DD HH:mm
    formatDateTime(val) {
      if (!val) return '-';
      const date = new Date(val);
      if (isNaN(date.getTime())) return '-';

      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffHours = diffMs / (1000 * 60 * 60);
      const diffDays = diffHours / 24;

      // 超過等於7天，展示完整日期時間
      if (diffDays >= 7) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const h = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}`;
      }
      // 24小時 ~ 7天以內：天數 ago
      else if (diffHours >= 24) {
        return `${Math.floor(diffDays)}d ago`;
      }
      // 24小時以內：小時 ago
      else {
        return `${Math.floor(diffHours)}h ago`;
      }
    }
  },
  created() {
    this.getUserCardsRoleNum();
    this.getCardsNumUser();
  },
  methods: {
    async getUserCardsRoleNum() {
      const res = await getUserCardsRoleNum();
      this.userCardsRoleNum = res.data;
    },
    getCardsNumUser() {
      const params = { ...this.listQuery, _page: this.listQuery._page - 1 };
      Object.keys(params).forEach(key => {
        if (params[key] == null) delete params[key];
      });
      getCardsNumUser(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      });
    },
  },
};
</script>

<style scoped>
.coin-record-card {
  background: #ffffff;
  border: 2px solid #ffe9b3;
  border-radius: 16px;
  padding: 24px;
  margin: 80px auto 0;
  max-width: 1024px; /* PC端最大寬度1024px，自動居中 */
  width: calc(100% - 40px); /* 兩側預留20px安全邊距，手機不貼邊 */
  box-sizing: border-box;
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-left {
  display: flex;
  align-items: center;
  gap:12px;
}

.coin-icon {
  width: 48px;
  height:48px;
  border-radius: 50%;
  background: #f7b529;
  color:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:bold;
  font-size:20px;
}

.balance-title {
  font-size:18px;
  color:#444;
}

.balance-num {
  font-size:42px;
  color:#f7b529;
  font-weight:bold;
}

.balance-right {
  display:flex;
  align-items:center;
  gap:8px;
}

.pulls-tag {
  background-color: #fff2cc;
  padding:6px 16px;
  border-radius:20px;
  color:#664400;
  font-size:16px;
}

.arrow-icon {
  color:#888;
  font-size:20px;
}

.divider {
  margin:20px 0;
  height:1px;
  background-color:#ffe9b3;
}

.activity-title {
  font-size:20px;
  color:#555;
  margin-bottom:16px;
}

.activity-item {
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:10px 0;
}

.item-left {
  display:flex;
  align-items:center;
  gap:10px;
}

.item-icon {
  width:24px;
  height:24px;
}

.item-desc {
  font-size:18px;
  color:#333;
}

.time-text {
  color:#888;
  font-size:16px;
}

.item-right {
  display:flex;
  align-items:center;
  gap:16px;
}

.coin-plus {
  color:#28a745;
  font-weight:bold;
  font-size:20px;
  display: inline-flex;
  align-items: center;
  gap:4px;
}

.coin-minus {
  color:#dc3545;
  font-weight:bold;
  font-size:20px;
  display: inline-flex;
  align-items: center;
  gap:4px;
}

.m-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ========== 手機媒體查詢 (小於768px) ========== */
@media (max-width:768px){
  .coin-record-card {
    padding:16px;
    margin-top:30px;
    width: calc(100% - 24px); /* 手機兩側留12px邊距 */
  }
  .balance-left svg {
    width:40px;
    height:40px;
  }
  .balance-title {
    font-size:16px;
  }
  .balance-num {
    font-size:32px;
  }
  .activity-title {
    font-size:18px;
  }
  .item-desc {
    font-size:16px;
  }
  .coin-plus, .coin-minus {
    font-size:18px;
  }
  .item-right svg {
    width:20px;
    height:20px;
  }
  .time-text {
    font-size:14px;
  }
  .activity-item {
    padding:8px 0;
  }
}
</style>
